import { NullableSignalLine } from "./nullable-signal-line";
import { VariableIsolineSignalBuffer } from "./variable-isoline-signal-buffer";

export class VariableIsolineSignalLine extends NullableSignalLine {
  constructor(settings) {
    super(settings);
  }

  createBuffer(settings) {
    this.signalBuffer = new VariableIsolineSignalBuffer(settings);
  }

  init() {
    this.filters = new Map();
    for (let filterIndex = 0; filterIndex < this.settings.filters.length; filterIndex++) {
      const filterInfo = this.settings.filters[filterIndex];
      this.filters.set(filterInfo.name, {
        index: filterIndex,
        filter: filterInfo.filter
      });
    }

    const selectedFilters = this.getSelectedFilters(this.settings.selectedFiltersNames);
    const bufferSettings = {
      pointCounterCreator: this.settings.pointCounterCreator,
      ppmm: this.settings.ppmm,
      plotSize: this.settings.parent.ref.settings.clientSize,
      windowSize: this.settings.parent.ref.settings.clientSize,
      freq: this.settings.freq,
      scaleX: this.settings.scaleX * this.settings.viewScale.x,
      scaleY: this.settings.scaleY * this.settings.viewScale.y,
      filters: selectedFilters,
      valuePixelConvertKoef: this.settings.valuePixelConvertKoef,
      isolineBorder: this.settings.isolineBorder,
      isDataSync: !this.settings.isBuffered,
      dataBufferSize: this.settings.dataBufferSize,
      pointCount: this.settings.pointCount
    };

    this.createBuffer(bufferSettings);
    this.signalBuffer.init();

    const gl = this.settings.gl;
    this.glBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, this.glBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, this.signalBuffer.pointBuffer, gl.DYNAMIC_DRAW);
  }

  getSelectedFilters(selectedFiltersNames) {
    let selectedFilters = [];
    selectedFilters.length = selectedFiltersNames.length;
    for (let i = 0; i < selectedFiltersNames.length; i++) {
      selectedFilters[i] = this.filters.get(selectedFiltersNames[i]);
    }
    selectedFilters.sort((a, b) => a.index - b.index);
    return selectedFilters;
  }

  setIsolineChangeAction(action) {
    this.signalBuffer.onIsolineChangeAction = function (isoline) {
      this.uniforms.u_shift[1] = this.settings.relatedLocation.y - isoline * this.settings.valuePixelConvertKoef * this.signalBuffer.settings.scaleY;
      action(isoline);
    }.bind(this);
  }

  tryUpdateMeanSignalValue() {
    this.signalBuffer.tryUpdateMeanSignalValue();
  }

  setFilters(selectedFiltersNames) {
    const gl = this.settings.gl;
    this.signalBuffer.setFilters(this.getSelectedFilters(selectedFiltersNames));
    gl.bindBuffer(gl.ARRAY_BUFFER, this.glBuffer);
    //gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.signalBuffer.pointBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, this.signalBuffer.pointBuffer, gl.DYNAMIC_DRAW);
  }
}
